import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { TimeframeWithLocalTimes } from '../../api/shared';
import { RecordingSegment } from '../../read';
export class HearingPlaybackData {
    /**
     * @param id Identifies the Hearing
     * @param courtSystemId Identifies the court system the hearing belongs to
     * @param locationId Identifies the courtroom the hearing belongs to
     * @param recordingId Identifies the matching recording for the hearing
     * @param recordingSegments The segments of the recording accessible to playback based on hearing times, recording times, and user permissions
     * @param sealedSegments An array of non-overlapping timeframes that have been 'sealed'
     * @param hasVideo Whether the hearing's recording has video
     * @param hasMultiChannel Whether the hearing's recording has a multichannel playlist
     * @param audioChannelCount The number of audio channels in the hearing's recording
     * @param onTheRecordTimeframes Timeframes in which this hearing's recording is on the record
     * @param availableTimeframes The precise local times that the user can access in this recording.
     */
    constructor(id, courtSystemId, locationId, recordingId, recordingSegments, sealedSegments, hasVideo, hasMultiChannel, audioChannelCount, onTheRecordTimeframes, availableTimeframes) {
        this.id = id;
        this.courtSystemId = courtSystemId;
        this.locationId = locationId;
        this.recordingId = recordingId;
        this.sealedSegments = sealedSegments;
        this.hasVideo = hasVideo;
        this.hasMultiChannel = hasMultiChannel;
        this.audioChannelCount = audioChannelCount;
        this.onTheRecordTimeframes = onTheRecordTimeframes;
        this.recordingSegments = recordingSegments;
        this.availableTimeframes = availableTimeframes;
    }
}
__decorate([
    Type(() => RecordingSegment),
    __metadata("design:type", Array)
], HearingPlaybackData.prototype, "recordingSegments", void 0);
__decorate([
    Type(() => TimeframeWithLocalTimes),
    __metadata("design:type", Array)
], HearingPlaybackData.prototype, "availableTimeframes", void 0);
